"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _typeaheadMultiSelect = require("./typeaheadMultiSelect.style");
var _TypeaheadMultiSelect = require("./TypeaheadMultiSelect");
var _ = require("..");
var _reactSelect = require("react-select");
var _Icon = _interopRequireDefault(require("../Icon"));
var _Label = _interopRequireDefault(require("../Label"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const TypeaheadMultiSelectSelect = props => {
  const {
      label,
      renderValue = 'label',
      isLoading,
      width,
      fit = 'medium'
    } = props,
    rest = __rest(props, ["label", "renderValue", "isLoading", "width", "fit"]);
  const DropdownIndicator = props => {
    return (0, _jsxRuntime.jsx)(_reactSelect.components.DropdownIndicator, (0, _extends2["default"])({}, props, {
      children: (0, _jsxRuntime.jsx)(_Icon["default"], {
        name: "chevron-down",
        size: fit === 'large' ? '24' : '20'
      })
    }));
  };
  return (0, _jsxRuntime.jsxs)(_typeaheadMultiSelect.Components.Wrapper, (0, _extends2["default"])({
    width: width
  }, {
    children: [label && (0, _jsxRuntime.jsx)(_Label["default"], (0, _extends2["default"])({
      fit: fit,
      label: label
    }, rest)), (0, _jsxRuntime.jsx)(_typeaheadMultiSelect.Components.StyledSelect, (0, _extends2["default"])({
      classNamePrefix: "MultiSelect",
      components: {
        MultiValueLabel: props => (0, _jsxRuntime.jsx)(_TypeaheadMultiSelect.MultiValueLabel, (0, _extends2["default"])({}, props, {
          renderValue: renderValue
        })),
        LoadingIndicator: undefined,
        DropdownIndicator
      },
      loadingMessage: () => (0, _jsxRuntime.jsx)(_.LoadingIndicator, {}),
      isLoading: isLoading,
      isMulti: true
    }, rest))]
  }));
};
var _default = exports["default"] = TypeaheadMultiSelectSelect;